import loadBlock from './block'
import loadComponent from './component'

export default function (editor, opts) {
  const defaultOptions = {
    componentType: 'nv-alert',
    componentName: 'Header notification',
    category: 'Components',
    css: {
      root: ['alert', 'alert-dismissible', 'nv-alert', 'nv-alert--with-icon']
    },
  };

  const options = {
    ...defaultOptions,
    ...opts
  };
  loadComponent(editor, options);
  loadBlock(editor, options);
}
